import { TagList } from "components/tags";
import { ITag } from "services/types";

import "./style/FilterByTag.scss";
import { useCreatorTagsQuery } from "../../../queries";
import { useCallback, useEffect, useMemo } from "react";

interface IFilterByTag {
  userId: string;
  selectedTags: string[];
  changeTags: (name: string) => void;
  topic: string;
  onLoaded: () => void;
}

export const FilterByTag = ({ userId, changeTags, selectedTags, topic, onLoaded }: IFilterByTag) => {
  const { isError, isSuccess, data } = useCreatorTagsQuery(userId);

  const adaptTags = useCallback((data: ITag) => {
    const tags = Object.keys(data);

    return tags.map(tag => ({ name: tag, count: 0 }));
  }, []);

  const tags = useMemo(() => {
    if (!isSuccess) {
      return [];
    }

    if (topic === "i") {
      return adaptTags(data.tags.images);
    }

    if (topic === "g") {
      return adaptTags(data.tags.gifs);
    }

    return adaptTags(data.tags.all);
  }, [adaptTags, topic, data, isSuccess]);

  useEffect(() => {
    if (isSuccess || isError) {
      onLoaded();
    }
  }, [isSuccess, isError, onLoaded]);

  if (isError) {
    return <p>Error loading tags....</p>;
  }

  if (!tags || !tags.length) {
    return null;
  }

  return (
    <div className="FilterByTag">
      <h2 className="FilterByTag-Title">Gifs/Images by {userId}:</h2>
      <p className="FilterByTag-Description">Filter {userId}'s porn gifs/images by tag</p>
      <TagList
        tags={tags}
        selectedTags={selectedTags}
        changeTags={changeTags}
        secondRow
      />
    </div>
  );
};
